import React from 'react';
import SafeIcon from '../common/SafeIcon';

function FeatureCard({ icon, title, description, accent = '' }) {
  return (
    <div className={`feature-card ${accent}`}>
      <span className="feature-icon-wrapper">
        <SafeIcon icon={icon} />
      </span>
      <div className="feature-content">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
}

export default FeatureCard;